export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((f) => ({
    "@type": "Question",
    "name": f.question,
    "acceptedAnswer": { "@type": "Answer", "text": f.answer }
  }))
});

export const CityFAQ = ({ faqs, title, prefix }) => (
  <section className="py-20 bg-[#EBEAE5]" data-testid={`${prefix}-faq-section`}>
    <div className="max-w-4xl mx-auto px-6">
      <span className="inline-block uppercase text-xs font-manrope font-semibold tracking-[0.2em] text-[#C45A41] mb-4">Common Questions</span>
      <h2 className="font-outfit font-[850] text-3xl sm:text-4xl text-[#143628] tracking-tight mb-10">{title}</h2>
      <div className="space-y-4">
        {faqs.map((faq, i) => (
          <div key={i} className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300" data-testid={`${prefix}-faq-item-${i}`}>
            <h3 className="font-outfit font-bold text-lg text-[#143628] mb-3">{faq.question}</h3>
            <p className="font-manrope text-[#4A6359] leading-relaxed">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
